import { render, staticRenderFns } from "./uploadPdf.vue?vue&type=template&id=62d7eba8&scoped=true&"
import script from "./uploadPdf.vue?vue&type=script&lang=js&"
export * from "./uploadPdf.vue?vue&type=script&lang=js&"
import style0 from "./uploadPdf.vue?vue&type=style&index=0&id=62d7eba8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d7eba8",
  null
  
)

export default component.exports